import "./orden_online.css";

export { default as Listado } from "./Listado";
export { default as Detalle } from "./Detalle";
export { default as Editar } from "./Editar";
